import { useQuery } from '@tanstack/react-query';
import QUERY_KEYS from '../utils/QueryKeys';
import { Cart } from '../models';

export default function useCart(id, options = {}) {
  // MUST fetch via the show endpoint (Cart.find). The index endpoint
  // (Cart.where({ id })) 404s for real customers -- Api::CartsController#index
  // requires filter[for_email] for non-admins -- so every consumer of this hook
  // silently got no cart outside admin sessions and offer auto-apply never ran
  // (found 2026-07-27 investigating the missing GRAD27 discount).
  //
  // `options` overrides the react-query defaults for callers that need
  // freshness (e.g. HolidayBuilder reads `qualifiesForFreeAnnouncements`, which
  // flips when a package is added elsewhere -- the app-wide QueryClient default
  // is `refetchOnMount: false`, so without an override the boolean would stay
  // stale across in-session navigation back to /holiday).
  return useQuery([QUERY_KEYS.CART, id], () => (
    Cart
      .find(id)
      .then((res) => res.data)
  ), { enabled: !!id, ...options });
}
